export default __webpack_public_path__ + "img/pin_icons/health_b.svg";